import { render, staticRenderFns } from "./kaoshi.vue?vue&type=template&id=788c1e66&scoped=true&"
import script from "./kaoshi.vue?vue&type=script&lang=js&"
export * from "./kaoshi.vue?vue&type=script&lang=js&"
import style0 from "./kaoshi.vue?vue&type=style&index=0&id=788c1e66&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "788c1e66",
  null
  
)

export default component.exports